
export const READY_STATE = {
  BEFORE_READY: 0,
  FAILURE: -1,
  READY: 1,
}

export function DaytonaReadyState () {
  //
}
